<div class="container mt-4">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h2 class="mb-0 bengali-text">ট্যাক্স রিসিপ্ট</h2>
      <div>
        <button class="btn btn-outline-lightning mr-2 bengali-text" (click)="goBack()">
          <i class="fas fa-arrow-left"></i> পিছনে
        </button>
        <button class="btn btn-outline-lightning bengali-text" (click)="printReceipt()">
          <i class="fas fa-print"></i> প্রিন্ট করুন
        </button>
      </div>
    </div>
    
    <div class="card-body">
      <div id="receiptPrintSection" class="bengali-text">
        <!-- Office Copy -->
        <div class="receipt-page mb-5">
          <div class="d-flex justify-content-between">
            <div class="logo-container">
              <img [src]="unionLogo" alt="Bangladesh Government Logo" height="100" *ngIf="unionLogo" />
            </div>
            <div class="text-center header-text flex-grow-1">
              <h2 class="mb-0 bengali-text"> {{ unionDomain.unionData.union_name }} (গ্রাহক কপি)</h2>
              <!-- <p class="mb-1 bengali-text">{{ unionDomain.unionData.union_name }}</p> -->
              <p class="mb-0 bengali-text">{{ unionDomain.unionData.upozilla_name }}, {{ unionDomain.unionData.zilla_name }} - </p>
              <p class="mb-0 bengali-text">ফোন : </p>
            </div>
            <div class="date-section text-right">
              <p class="bengali-text">তারিখ : {{ receipt.collection_date | date: 'dd/MM/yyyy' }}</p>
            </div>
          </div>

          <div class="d-flex justify-content-between mt-3">
            <div class="info-section" style="width: 50%;">
              <table class="info-table">
                <tr>
                  <td class="bengali-text">ধনকারীর নাম</td>
                  <td class="bengali-text">: {{ receipt.name }}</td>
                </tr>
                <tr>
                  <td class="bengali-text">গ্রাম</td>
                  <td class="bengali-text">: {{ receipt.gram_or_rasta }}</td>
                </tr>
                <tr>
                  <td class="bengali-text">আইডি নং</td>
                  <td>: {{ receipt.qr_code }}</td>
                </tr>
              </table>
            </div>
            <div class="info-section" style="width: 50%;">
              <table class="info-table">
                <tr>
                  <td class="bengali-text">পিতার নাম</td>
                  <td class="bengali-text">: {{ receipt.gurdian_name || 'তথ্য নেই' }}</td>
                </tr>
                <tr>
                  <td class="bengali-text">ওয়ার্ড নং</td>
                  <td>: {{ receipt.ward_number }}</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="tax-details mt-4">
            <table class="table table-bordered tax-table">
              <thead>
                <tr>
                  <th style="width: 15%;" class="bengali-text">ক্রমিক নং</th>
                  <th class="bengali-text">বর্ণনা</th>
                  <th style="width: 20%;" class="bengali-text">পরিমাণ (টাকা)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center bengali-text">১</td>
                  <td class="bengali-text">চলতি ট্যাক্স</td>
                  <td class="text-right">{{ receipt.tax_amount }}.০০</td>
                </tr>
                <tr *ngIf="receipt.arrears">
                  <td class="text-center bengali-text">২</td>
                  <td class="bengali-text">বকেয়া ট্যাক্স</td>
                  <td class="text-right">{{ receipt.arrears }}.০০</td>
                </tr>
                <tr *ngIf="!receipt.arrears">
                  <td class="text-center bengali-text">২</td>
                  <td class="bengali-text">বকেয়া ট্যাক্স ()</td>
                  <td class="text-right">০.০০</td>
                </tr>
                <tr>
                  <td colspan="2" class="text-right font-weight-bold bengali-text">মোট ধার্যকৃত ট্যাক্স</td>
                  <td class="text-right bengali-text">{{ calculateTotal() }} টাকা।</td>
                </tr>
                <tr>
                  <td colspan="2" class="text-right font-weight-bold bengali-text">আদায়কৃত ট্যাক্স</td>
                  <td class="text-right bengali-text">{{ calculateTotal() }} টাকা।</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="amount-in-words mt-2 mb-4">
            <p class="bengali-text">কথায় : <span class="underline bengali-text">{{ amountInWords }}</span> টাকা মাত্র</p>
          </div>

          <div class="signatures mt-5 d-flex justify-content-between">
            <div class="signature-box text-center">
              <div class="signature-line"></div>
              <p class="bengali-text">স্বাক্ষর<br/>আদায়কারী</p>
            </div>
            <div class="signature-box text-center">
              <div class="signature-line"></div>
              <p class="bengali-text">সীল</p>
            </div>
            <div class="signature-box text-center">
              <div class="signature-line"></div>
              <p class="bengali-text">স্বাক্ষর<br/>খাজাঞ্চী</p>
            </div>
          </div>
        </div>

        <!-- Divider -->
        <div class="dotted-divider"></div>

        <!-- Office Copy -->
        <div class="receipt-page mt-5">
          <div class="d-flex justify-content-between">
            <div class="logo-container">
              <img [src]="unionLogo" alt="Bangladesh Government Logo" height="100" *ngIf="unionLogo" />
            </div>
            <div class="text-center header-text flex-grow-1">
              <h2 class="mb-0 bengali-text">{{ receipt.ward_number }} নং {{ unionDomain.unionData.union_name }} ইউনিয়ন পরিষদ (অফিস কপি)</h2>
              <p class="mb-1 bengali-text">{{ unionDomain.unionData.union_name }}</p>
              <p class="mb-0 bengali-text">{{ unionDomain.unionData.upozilla_name }}, {{ unionDomain.unionData.zilla_name }} - </p>
              <p class="mb-0 bengali-text">ফোন : </p>
            </div>
            <div class="date-section text-right">
              <p class="bengali-text">তারিখ : {{ receipt.collection_date | date: 'dd/MM/yyyy' }}</p>
            </div>
          </div>

          <div class="d-flex justify-content-between mt-3">
            <div class="info-section" style="width: 50%;">
              <table class="info-table">
                <tr>
                  <td class="bengali-text">ধনকারীর নাম</td>
                  <td class="bengali-text">: {{ receipt.name }}</td>
                </tr>
                <tr>
                  <td class="bengali-text">গ্রাম</td>
                  <td class="bengali-text">: {{ receipt.gram_or_rasta }}</td>
                </tr>
                <tr>
                  <td class="bengali-text">আইডি নং</td>
                  <td>: {{ receipt.qr_code }}</td>
                </tr>
              </table>
            </div>
            <div class="info-section" style="width: 50%;">
              <table class="info-table">
                <tr>
                  <td class="bengali-text">পিতার নাম</td>
                  <td class="bengali-text">: {{ receipt.gurdian_name || 'তথ্য নেই' }}</td>
                </tr>
                <tr>
                  <td class="bengali-text">ওয়ার্ড নং</td>
                  <td>: {{ receipt.ward_number }}</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="tax-details mt-4">
            <table class="table table-bordered tax-table">
              <thead>
                <tr>
                  <th style="width: 15%;" class="bengali-text">ক্রমিক নং</th>
                  <th class="bengali-text">বর্ণনা</th>
                  <th style="width: 20%;" class="bengali-text">পরিমাণ (টাকা)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center bengali-text">১</td>
                  <td class="bengali-text">চলতি ট্যাক্স</td>
                  <td class="text-right">{{ receipt.tax_amount }}.০০</td>
                </tr>
                <tr *ngIf="receipt.arrears">
                  <td class="text-center bengali-text">২</td>
                  <td class="bengali-text">বকেয়া ট্যাক্স</td>
                  <td class="text-right">{{ receipt.arrears }}.০০</td>
                </tr>
                <tr *ngIf="!receipt.arrears">
                  <td class="text-center bengali-text">২</td>
                  <td class="bengali-text">বকেয়া ট্যাক্স ()</td>
                  <td class="text-right">০.০০</td>
                </tr>
                <tr>
                  <td colspan="2" class="text-right font-weight-bold bengali-text">মোট ধার্যকৃত ট্যাক্স</td>
                  <td class="text-right bengali-text">{{ calculateTotal() }} টাকা।</td>
                </tr>
                <tr>
                  <td colspan="2" class="text-right font-weight-bold bengali-text">আদায়কৃত ট্যাক্স</td>
                  <td class="text-right bengali-text">{{ calculateTotal() }} টাকা।</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="amount-in-words mt-2 mb-4">
            <p class="bengali-text">কথায় : <span class="underline bengali-text">{{ amountInWords }}</span> টাকা মাত্র</p>
          </div>

          <div class="signatures mt-5 d-flex justify-content-between">
            <div class="signature-box text-center">
              <div class="signature-line"></div>
              <p class="bengali-text">স্বাক্ষর<br/>আদায়কারী</p>
            </div>
            <div class="signature-box text-center">
              <div class="signature-line"></div>
              <p class="bengali-text">সীল</p>
            </div>
            <div class="signature-box text-center">
              <div class="signature-line"></div>
              <p class="bengali-text">স্বাক্ষর<br/>খাজাঞ্চী</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
